import React, { useEffect, useState } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useInstall } from './InstallProvider';
import { shouldShowBanner } from '../services/install';

const InstallPrompt: React.FC = () => {
  const { t } = useLanguage();
  const { canInstall, bannerDismissed, isIOS, promptInstall, dismissBanner } = useInstall();
  const [delayPassed, setDelayPassed] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => setDelayPassed(true), isIOS ? 5000 : 3000);
    return () => clearTimeout(id);
  }, [isIOS]);

  if (!delayPassed || !shouldShowBanner({ canInstall, bannerDismissed })) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-slide-up">
      <div className="bg-white rounded-2xl shadow-xl p-4 max-w-md mx-auto border border-stone-100">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-14 h-14 bg-accent rounded-xl flex items-center justify-center">
            <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <circle cx="12" cy="12" r="6" opacity="0.5" />
              <circle cx="12" cy="12" r="2" fill="currentColor" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-semibold text-stone-900 text-base">
              {t('install.title') || 'Installer Breathe to Become'}
            </h3>
            <p className="text-sm text-stone-600 mt-1">
              {t('install.description') || 'Legg til på hjemskjermen for en bedre opplevelse'}
            </p>
            <div className="flex gap-3 mt-3">
              <button
                onClick={promptInstall}
                className="flex-1 px-4 py-2 bg-accent text-white text-sm font-medium rounded-full hover:bg-accent-dark transition-colors"
              >
                {isIOS ? (t('install.howTo') || 'Vis meg hvordan') : (t('install.button') || 'Installer')}
              </button>
              <button
                onClick={dismissBanner}
                className="px-4 py-2 text-stone-500 text-sm font-medium hover:text-stone-700 transition-colors"
              >
                {t('install.later') || 'Senere'}
              </button>
            </div>
          </div>
          <button
            onClick={dismissBanner}
            className="flex-shrink-0 text-stone-400 hover:text-stone-600 transition-colors"
            aria-label="Lukk"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
      <style>{`
        @keyframes slide-up { from { opacity: 0; transform: translateY(100%); } to { opacity: 1; transform: translateY(0); } }
        .animate-slide-up { animation: slide-up 0.3s ease-out; }
      `}</style>
    </div>
  );
};

export default InstallPrompt;
